import Button from '@material-ui/core/Button';
import FunctionButton from 'shared/components/FunctionButton';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { validateRequiredFields } from 'shared/utils/reduxFormHelpers';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from 'shared/reduxFormMaterialUi/TextField';

const requiredFields = [
	{ name: 'email', description: 'Email' },
	{ name: 'password', description: 'Password' },
];

const styles = theme => ({
	button: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.getContrastText(theme.palette.primary.main),
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
		},
	},
	inputField: {
		padding: '8px 0px 15px',
		width: '100%'
	},
	loginContainer: {
		/* Center this */
		margin: '0 auto',
		width: 350,
		padding: '2em',
		fontSize: '12pt',
		fontFamily: theme.typography.fontFamily,

		'@media only screen and (max-height: 600px) and (orientation: landscape)': {
			height: '70vh',
			overflow: 'auto',
		},
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			width: '70vw',
		},
	},
	loginHeader: {
		/* Center this */
		textAlign: 'center',
		fontSize: '14pt',
		padding: 8,
		fontWeight: 'bold',
	},
	loginInputArea: {
		paddingTop: 12,
		paddingBottom: 24,
	},
	loginSignUp: {
		textAlign: 'center',
		padding: 4,
	},
	submitContainer: {
		position: 'relative',
		textAlign: 'center',
		paddingBottom: 8,
	},
});

/**
 * Display a login form.
 * @param {React props} props
 */
const LoginForm = props => {
	const { cancelToken, classes, handleSubmit, login, isLoggingIn, switchModal } = props;
	
	return (
		<div className={classes.loginContainer}>
			<div className={classes.loginHeader}>Log In Here</div>
			<form onSubmit={handleSubmit(values => login(cancelToken, values.email, values.password))}>
				<div className={classes.loginInputArea}>
					<Field
						name="email"
						className={classes.inputField}
						label={<div style={{ marginTop: 10 }}>Email</div>}
						component={TextField}
					/>
					<Field
						name="password"
						type="password"
						className={classes.inputField}
						label={<div style={{ marginTop: 10 }}>Password</div>}
						component={TextField}
					/>
				</div>
				<div className={classes.submitContainer}>
					<Button type="submit" className={classes.button} disabled={isLoggingIn} >
						Login
					</Button>
					{isLoggingIn ? <IndeterminateCircularProgress /> : null}
				</div>
			</form>
			<div className={classes.loginSignUp}>
				Don&apos;t have an account?
				<FunctionButton label="Sign up" onClickFunction={switchModal} />
			</div>
		</div>
	);
};

LoginForm.propTypes = {
	cancelToken: PropTypes.objectOf(PropTypes.any).isRequired,
	classes: PropTypes.shape({
		button: PropTypes.string,
		inputField: PropTypes.string,
		loginContainer: PropTypes.string,
		loginHeader: PropTypes.string,
		loginInputArea: PropTypes.string,
		loginSignUp: PropTypes.string,
		submitContainer: PropTypes.string,
	}).isRequired,
	handleSubmit: PropTypes.func.isRequired,
	isLoggingIn: PropTypes.bool.isRequired,
	login: PropTypes.func.isRequired,
	switchModal: PropTypes.func.isRequired,
};

// Testing
export { LoginForm as LoginFormClass };

export default reduxForm({
	form: 'LoginForm',
	validate: validateRequiredFields(requiredFields),
})(withStyles(styles, { name: 'LoginForm' })(LoginForm));
